import * as React from 'react';
import { Svg } from '../icon';

type LogoProps = any & {
    variantColor?: 'dark' | 'light'
    includeAeris?: boolean
}

const Logo: React.FC<LogoProps> = (props: LogoProps): React.ReactElement => {
    const {
        variantColor,
        includeAeris,
        ...rest
    } = props;

    let fillColor = '#010101';
    if (variantColor === 'light') {
        fillColor = '#ffffff';
    }

    const opts = { ...props };
    opts.height = opts.height || 100;

    return (
        <Svg viewBox="0 0 384.25 90" xmlSpace="preserve" {...opts}>
            <g fill={fillColor}>
                <g>
                    <g>
                        <path d="M5.5,55.1v9.2H0V37.8h10.8c5.6,0,9.3,3,9.3,8.7c0,5.6-3.7,8.6-9.3,8.6H5.5z M10.5,42.5h-5v7.9h5c2.9,0,4.2-1.6,4.2-3.9
                            C14.7,44.1,13.3,42.5,10.5,42.5z"
                        />
                        <path d="M44,37.8l4.6,17.8L53,37.8h5.4l-6.9,26.5h-5.1l-4.7-17.5l-4.7,17.5H32l-6.9-26.5h5.6L35,55.6l4.7-17.8H44z" />
                        <path d="M68.7,56.8c0.7,2.3,2.7,3.4,5.3,3.4c2.7,0,4.5-1.2,4.5-3.3c0-1.6-1-2.5-3.2-3l-4.8-1.1c-3.8-0.9-6.7-2.9-6.7-7.3
                            c0-4.8,4-8.2,9.5-8.2c6,0,9.5,3.2,10.4,7.7h-5.5c-0.6-1.8-2.1-3.2-4.9-3.2c-2.5,0-4.2,1.2-4.2,3.1c0,1.5,1,2.4,3,2.9l4.8,1.1
                            c4.3,1,7,3.5,7,7.5c0,5.1-4.2,8.3-9.8,8.3c-5.9,0-10.1-2.9-11-8H68.7z"
                        />
                    </g>
                    <g>
                        <path d="M211.4,37.7l6.2,22.7l6.1-22.7h2.2l-7.2,26.4h-2l-6.2-22.5l-6.2,22.5h-1.9l-7.2-26.4h2.2l6.1,22.7l6.2-22.7H211.4z" />
                        <path d="M249.2,37.7v2h-14.3v9.8h12.9v2h-12.9v10.6h14.3v2h-16.4V37.7H249.2z" />
                        <path d="M267.6,37.7l10.5,26.4h-2.2l-3.4-8.7h-11.7l-3.4,8.7h-2.2l10.5-26.4H267.6z M261.5,53.5h10.2l-5.1-12.9L261.5,53.5z" />
                        <path d="M280.9,37.7h21.5v2h-9.7v24.4h-2.2V39.8h-9.6V37.7z" />
                        <path d="M330.9,37.7v26.4h-2.2V51.6h-16.8v12.6h-2.2V37.7h2.2v11.8h16.8V37.7H330.9z" />
                        <path d="M356.7,37.7v2h-14.3v9.8h12.9v2h-12.9v10.6h14.3v2h-16.4V37.7H356.7z" />
                        <path d="M367.2,52.5v11.7H365V37.7h9.3c5.2,0,8.3,2.6,8.3,7.4c0,4.3-2.5,6.8-6.7,7.3l8,11.8h-2.5l-7.8-11.7H367.2z M367.2,50.6
                            h7.1c4,0,6.2-2,6.2-5.4c0-3.5-2.2-5.4-6.2-5.4h-7.1V50.6z"
                        />
                    </g>
                    <g>
                        <g>
                            <g>
                                <g>
                                    <path d="M173.6,21.3c-0.3,0.2-0.9,0.3-1.3,0.3h-68.7c-0.4,0-0.8-0.3-1-0.7L94.4,0.7C94.2,0.3,94.4,0,94.8,0l11.7,0
                                        c0.4,0,1,0.2,1.3,0.4l20.9,17.3c0.3,0.2,0.9,0.4,1.3,0.4h42.2c0.4,0,1,0.1,1.3,0.3l2.3,1.2c0.3,0.2,0.3,0.5,0,0.6L173.6,21.3z"
                                    />
                                    <g>
                                        <path d="M145.7,16.5l-0.4-0.9c-0.1-0.2-0.4-0.4-0.6-0.4h-10.7c-0.2,0-0.5,0.2-0.6,0.4l-0.4,0.9c0,0.1-0.1,0.2-0.1,0.4h12.8
                                            C145.8,16.7,145.8,16.6,145.7,16.5z"
                                        />
                                    </g>
                                    <path d="M159.4,29.2c-5.1,0-9.3,3.7-10.2,8.5h-4.1l-0.4,3.7h4.5c0.9,4.8,5.1,8.5,10.2,8.5c5.7,0,10.4-4.6,10.4-10.4
                                        S165.1,29.2,159.4,29.2z M164.9,44.7c0.6-1.2,1-2.6,1-4c0-4.5-3.2-8.1-7.2-8.5c0.3,0,0.5-0.1,0.8-0.1c4.1,0,7.5,3.4,7.5,7.5
                                        C166.9,41.6,166.1,43.3,164.9,44.7z"
                                    />
                                    <g>
                                        <path d="M134.1,41.4l-0.4-3.7h-4.1c-0.8-4.8-4.6-8.5-9.3-8.5c-5.2,0-9.4,4.6-9.4,10.4c0,0,0,0,0,0s0,0,0,0c0,0,0,0.1,0,0.1
                                            c0.1,5.7,4.2,10.2,9.4,10.2h0c0,0,0,0,0,0c4.6,0,8.4-3.7,9.2-8.5H134.1z M119.3,47.1c-0.3,0-0.5-0.1-0.8-0.1
                                            c4-0.4,7.2-4,7.2-8.5c0-1.5-0.4-2.8-1-4c1.2,1.3,2,3.1,2,5.1C126.8,43.7,123.5,47.1,119.3,47.1z"
                                        />
                                        <path d="M109.7,39.6c0-4.4,2.3-8.3,5.7-10.2c-4.1,1.6-7,5.5-7,10.2c0,4.7,2.9,8.6,7,10.2C112.1,47.9,109.7,44,109.7,39.6z" />
                                    </g>
                                    <path d="M132.9,22.7l5.8,47.7c0,0.4,0.3,0.7,0.7,0.7c0.4,0,0.7-0.3,0.7-0.7l5.8-47.7H132.9z" />
                                </g>
                            </g>
                            <g>
                                <g>
                                    <path
                                        fill="#06CCED"
                                        d="M149.7,61.5c9.4,1.8,14.4,6,11.2,10c-3.5,4.4-15.5,6.8-26.8,5.5c-10.4-1.3-16.5-5.3-14.7-9.4c0,0,0,0,0,0
                                        c-3.9,4.9,3.1,10.1,15.7,11.7c12.6,1.5,26.1-1.2,30-6.1C169,68.3,162.1,63.1,149.7,61.5z"
                                    />
                                </g>
                                <g>
                                    <path
                                        fill="#0146E6"
                                        d="M147.5,80.1c-13.9,1.4-28-1.9-31.6-7.3c-3.1-4.7,2.9-9.5,13.7-11.5c-13.3,1.9-21.1,7.4-17.5,12.9
                                        c3.8,5.8,19.1,9.3,34.1,7.9c14.1-1.4,22.9-6.7,20.8-12.2C167.6,74.5,159.7,78.9,147.5,80.1z"
                                    />
                                </g>
                                <g>
                                    <path
                                        fill="#3ABA50"
                                        d="M176.9,69.7c0,8.1-16.8,14.6-37.6,14.6c-20.8,0-37.6-6.5-37.6-14.6c0-4.2,4.5-7.9,11.8-10.6
                                        c-9.2,2.9-15,7.4-15,12.3c0,8.8,18.3,15.9,41,15.9s41-7.1,41-15.9c0-5.2-6.4-9.8-16.3-12.7C171.9,61.4,176.9,65.4,176.9,69.7z"
                                    />
                                </g>
                            </g>
                        </g>
                    </g>
                </g>
                {includeAeris && (
                    <g fillOpacity={0.4}>
                        <g>
                            <path d="M236.6,87.7c0,1.5-1,2.2-2.6,2.2h-3v-7.7h2.7c1.6,0,2.6,0.7,2.6,2.1c0,0.8-0.4,1.4-1,1.6
                            C236.1,86.1,236.6,86.8,236.6,87.7z M233.7,85.4c0.9,0,1.4-0.3,1.4-1.1c0-0.7-0.5-1-1.4-1h-1.4v2.1H233.7z M232.3,88.7h1.7
                            c0.9,0,1.4-0.4,1.4-1.1c0-0.7-0.5-1.1-1.4-1.1h-1.7V88.7z"
                            />
                            <path d="M244.1,82.1h1.4l-2.8,4.7v3.1h-1.3v-3.1l-2.8-4.7h1.4l2.1,3.5L244.1,82.1z" />
                            <path d="M255,89.9l-2.9-7.7h1.4l2.2,6l2.2-6h1.3l-2.9,7.7H255z" />
                            <path d="M264.8,82.1l3,7.7h-1.3l-0.8-2.1h-3l-0.8,2.1h-1.3l3-7.7H264.8z M263.1,86.6h2.1l-1.1-2.9L263.1,86.6z" />
                            <path d="M271.9,89.9h-1.3v-7.7h1.3V89.9z" />
                            <path d="M276,87.7c0.3,0.8,0.9,1.2,1.8,1.2c0.9,0,1.5-0.4,1.5-1.1c0-0.5-0.3-0.9-1.1-1l-1.3-0.3
                            c-1.1-0.3-1.9-0.8-1.9-2.1c0-1.3,1.1-2.3,2.6-2.3c1.7,0,2.7,0.9,2.9,2.1h-1.3c-0.2-0.6-0.7-1-1.6-1c-0.8,0-1.4,0.4-1.4,1.1
                            c0,0.5,0.3,0.8,1,1l1.4,0.3c1.2,0.3,2,1,2,2.1c0,1.5-1.2,2.3-2.8,2.3c-1.6,0-2.8-0.8-3.1-2.3H276z"
                            />
                            <path d="M286.9,82.1l3,7.7h-1.3l-0.8-2.1h-3l-0.8,2.1h-1.3l3-7.7H286.9z M285.2,86.6h2.1l-1.1-2.9L285.2,86.6z" />
                            <path d="M292.7,82.1h1.3v6.6h3.7v1.2h-5V82.1z" />
                            <path d="M304.3,82.1l3,7.7h-1.3l-0.8-2.1h-3l-0.8,2.1h-1.3l3-7.7H304.3z M302.6,86.6h2.1l-1.1-2.9L302.6,86.6z" />
                            <path d="M318,85.9l2.8,4h-1.5l-2-2.9l-2,2.9h-1.5l2.7-4l-2.6-3.8h1.5l1.9,2.7l1.9-2.7h1.5L318,85.9z" />
                            <path d="M327.9,82.1l1.5,5.7l1.4-5.7h1.3l-2,7.7h-1.2l-1.5-5.5l-1.5,5.5h-1.2l-2-7.7h1.3l1.4,5.7l1.5-5.7H327.9z" />
                            <path d="M339.8,82.1v1.2H336v2h3.4v1.1H336v2.2h3.8v1.2h-5.1v-7.7H339.8z" />
                            <path d="M346.5,82.1l3,7.7h-1.3l-0.8-2.1h-3l-0.8,2.1h-1.3l3-7.7H346.5z M344.8,86.6h2.1l-1.1-2.9L344.8,86.6z" />
                            <path d="M351,82.1h6.5v1.2h-2.6v6.6h-1.3v-6.6H351V82.1z" />
                            <path d="M366.9,82.1v7.7h-1.3v-3.4h-3.9v3.4h-1.3v-7.7h1.3v3.2h3.9v-3.2H366.9z" />
                            <path d="M375.3,82.1v1.2h-3.8v2h3.4v1.1h-3.4v2.2h3.8v1.2h-5.1v-7.7H375.3z" />
                            <path d="M379.7,86.7v3.1h-1.3v-7.7h3c1.6,0,2.6,0.8,2.6,2.3c0,1.3-0.8,2-2,2.2l2.2,3.2h-1.5l-2.2-3.1H379.7z
                            M379.7,85.6h1.7c0.9,0,1.4-0.5,1.4-1.2c0-0.7-0.5-1.2-1.4-1.2h-1.7V85.6z"
                            />
                        </g>
                        <g>
                            <path d="M99.4,82.1H0v7.8h117.5C110.1,88.2,103.7,85.6,99.4,82.1z" />
                            <path d="M179.5,82.1c-4.3,3.5-10.7,6.1-18.1,7.8h64v-7.8H179.5z" />
                        </g>
                    </g>
                )}
            </g>
        </Svg>
    );
};

export default Logo;
